import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=270bc762&scoped=true"
import script from "./roles.vue?vue&type=script&lang=ts"
export * from "./roles.vue?vue&type=script&lang=ts"
import style0 from "./roles.vue?vue&type=style&index=0&id=270bc762&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270bc762",
  null
  
)

export default component.exports